/*
 * @Author: MengDebiao
 * @Date: 2019-09-19 11:13:10
 * @Last Modified by: MengDebiao
 * @Last Modified time: 2019-11-09 10:32:29
 */

/**
 * 电子面单模块路由文件
 */

export default [
  {
    path: '/openExpressServices',
    name: 'OpenExpressServices',
    meta: { title: '开通电子面单服务' },
    component: () => import('@/views/electronicExpress/openExpressServices')
  },
  {
    path: '/myOrderingService',
    name: 'MyOrderingService',
    meta: { title: '我的订购服务' },
    component: () => import('@/views/electronicExpress/myOrderingService')
  },
  {
    path: '/faceListDetails',
    name: 'FaceListDetails',
    meta: { title: '面单详情' },
    component: () => import('@/views/electronicExpress/myOrderingService/faceListDetails')
  },
  {
    path: '/rechargeRecord',
    name: 'RechargeRecord',
    meta: { title: '充值记录' },
    component: () => import('@/views/electronicExpress/myOrderingService/rechargeRecord')
  }
]
